import React, { forwardRef, Ref } from 'react';
import classnames from 'classnames';
import { Icon } from '@eika/icon';

import { SharedButtonProps } from './Props';

import { isStandardIcon, mapButtonTypes, mapIconSizes } from './mapper';

import '@eika/button-style';

export type ButtonProps = SharedButtonProps;

const Button = forwardRef(
    (
        {
            children,
            className,
            buttonType = 'positive',
            size = 'standard',
            icon,
            type = 'button',
            inverted = false,
            ...rest
        }: ButtonProps,
        ref: Ref<HTMLButtonElement>
    ): JSX.Element => {
        const { type: targetButtonType, size: targetButtonSize } = mapButtonTypes(buttonType, size);
        const iconClassNames = mapIconSizes(targetButtonType, targetButtonSize);

        return (
            <button
                {...rest}
                // eslint-disable-next-line react/button-has-type
                type={type}
                className={classnames(
                    'sgw-button',
                    'sgw-button-common',
                    className,
                    `button--${targetButtonType}`,
                    `button--size-${targetButtonSize}`,
                    {
                        'action-button__button': targetButtonType === 'action',
                        inverted,
                    }
                )}
                ref={ref}
            >
                {icon && (
                    <>
                        {isStandardIcon(targetButtonType) ? (
                            <span className="sgw-button__icon-container">
                                <Icon type={icon} className={iconClassNames} />
                            </span>
                        ) : (
                            <Icon type={icon} className={iconClassNames} />
                        )}
                    </>
                )}
                <>{children}</>
            </button>
        );
    }
);

export default Button;
